import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  ListItemIcon,
  Divider,
  Avatar,
  TextField,
  InputAdornment,
  Button,
  Modal,
  TableContainer,
  TableBody,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  IconButton,
} from "@mui/material";
import axios from "axios";
import { useOutletContext } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import authAxiosInstance from "../../services/authAxioInstance";
import {
  EDUCATIONAL_DOCUMENTS_PRODUCT_NAME,
  getProductsConfigForCompany,
  resolveEducationalCreditProductCode,
} from "../../config";
import { useLogger } from "../../hooks/useLogger";
import { toast } from "react-toastify";
import { developerTollApi } from "../../services/developerTollApi";

const AddCredits = (props) => {
  const {
    addCreditOpen,
    setAddCreditOpen,
    loader,
    setLoader,
    productData,
    selectedSubItem,
    getcredits,
    allCredits,
  } = props;
  const logEvent = useLogger();
  const dispatch = useDispatch();
  const { profileData } = useSelector((state) => state.profile);
  const { data = {}, status } = useSelector((state) => state.credit);
  const [allCraditData, setAllCraditData] = useState({});
  const [paymentsuccess, setPaymentsuccess] = useState(false);
  const [showBulkText, setShowBulkText] = useState(false);
  const [credits, setCredits] = useState(1);
  const [productConfig, setProductConfig] = useState({});
  const minimumCredits = productConfig?.minQuantity ?? 25;
  const [amountWithGST, setAmountWithGST] = useState(118);
  const isEducationalDocumentsProduct =
    productData?.product_name?.toLowerCase() ===
    EDUCATIONAL_DOCUMENTS_PRODUCT_NAME.toLowerCase();
  const resolvedEducationalCreditCode = resolveEducationalCreditProductCode({
    productName: productData?.product_name,
    tagName: selectedSubItem?.tag_name,
  });
  const effectiveCreditProductCode =
    resolvedEducationalCreditCode || productConfig?.creditTemplateId;
  const creditDisplayName =
    isEducationalDocumentsProduct && selectedSubItem?.tag_name
      ? selectedSubItem.tag_name
      : productData?.product_name;

  useEffect(() => {
    const totalCredits = credits * productConfig?.price;
    const gst = (totalCredits * 18) / 100;
    const total = totalCredits + gst;
    setAmountWithGST(total.toFixed(2));
  }, [credits, productConfig]);

  useEffect(() => {
    setCredits(productConfig?.minQuantity);
  }, [addCreditOpen]);

  useEffect(() => {
    const productsConfig = getProductsConfigForCompany(profileData?.company_id);
    const product = productsConfig.find(
      (p) =>
        p.productName.toLowerCase() === productData?.product_name.toLowerCase()
    );
    setProductConfig(product);
    setCredits(product?.minQuantity);
  }, [productData, profileData?.company_id]);

  const increasecredits = () => {
    setCredits((prev) => prev + 1);
  };

  const decreasecredits = () => {
    if (credits > productConfig?.minQuantity) setCredits((prev) => prev - 1);
  };

  useEffect(() => {
    if (data.status) {
      setAllCraditData(data.credit_balance || {});
    }
  }, [data, data.status]);

  const handleBackToCredits = async () => {
    setLoader(true);
    const result = "await dispatch(credit());";
    const updatedCredits = result?.payload?.credit_balance;
    if (updatedCredits) {
      setAllCraditData(updatedCredits);
    }
    setLoader(false);
    setPaymentsuccess(false);
    setAddCreditOpen(false);
  };

  const loadRazorpay = () => {
    if (
      !document.querySelector(
        'script[src="https://checkout.razorpay.com/v1/checkout.js"]'
      )
    ) {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => {
        // console.log('Razorpay script loaded.');
      };
      script.onerror = () => {
        console.error("Razorpay script could not be loaded.");
      };
      document.body.appendChild(script);
    }
  };

  const generateOrderID = async (amount) => {
    try {
      const response = await authAxiosInstance.post(
        `/EsignServices/razorpay/order/${amount}`
      );
      return response.data;
    } catch (error) {
      console.error(
        "Order ID Generation Failed:",
        error.response?.data || error.message
      );
      return null;
    }
  };

  const handlePayment = async () => {
    if (isEducationalDocumentsProduct && !effectiveCreditProductCode) {
      toast.error(
        "Unable to identify the selected educational document type for credits."
      );
      return;
    }

    logEvent(
      "Clicked",
      "Pay button clicked",
      `${productData?.product_name}/addCredit`
    );
    const fixed = Math.round(amountWithGST * 100);
    const orderData = await generateOrderID(fixed);
    console.log(orderData);
    if (!orderData?.id) {
      alert("Failed to generate Order ID. Please try again.");
      return;
    }
    const options = {
      key: "rzp_live_fM3BhWsNG9FN5V", // Replace with your Razorpay key ID
      amount: `${amountWithGST * 100}`, // Amount in paisa
      currency: "INR",
      name: "Meon Technologies",
      description: `Transaction For ${productConfig?.creditName} Recharge from Developer`,
      image: "https://meon.co.in/static/meon/img/logo-new.svg",
      order_id: orderData.id,
      handler: function (response) {
        console.log(`Payment Successful! Payment ID: ${response}`, response);
        setLoader(true);
        const creditlog = `${profileData?.company_id} | ${Number(
          credits?.toString().trim() || 0
        )} | ${Number(amountWithGST)} | ${response.razorpay_payment_id} | ${
          productData?.product_name
        }`;
        logEvent("Payment_credit", creditlog, "Credit");
        const paymentFunction =
          productConfig?.productName?.toLowerCase() === "esign"
            ? checkEsignPayment
            : effectiveCreditProductCode
            ? handleWalletWisePayment
            : checkPayment;
        paymentFunction(response.razorpay_payment_id)
          .then((res) => {
            if (res?.data?.status === true) {
              setAddCreditOpen(false);
              setPaymentsuccess(true);
              setLoader(false);
              getcredits();
            } else {
              console.log(res);
              toast.error(res?.data?.message || res?.data?.msg || "Payment verification failed. Please contact support.");
              setLoader(false);
            }
          })
          .catch((error) => console.error(error));
      },
      prefill: {
        name: "",
        email: "",
        contact: "",
      },
      notes: {
        address: "",
      },
      theme: {
        color: "#007bff",
      },
      modal: {
        ondismiss: function () {
          // alert('Payment failed or was dismissed!');
        },
      },
    };

    if (window.Razorpay) {
      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } else {
      alert("Razorpay SDK failed to load. Please try again.");
    }
  };

  React.useEffect(() => {
    loadRazorpay();
  }, []);

  const checkPayment = async (transactionID) => {
    const url = "https://invoice.meon.co.in/process_api_with_invoice";

    const headers = {
      Authorization: "Bearer ssdjhfmbsjdfhvssfeiorfhjvkbercnjsljcf3roujf",
      "Content-Type": "application/json",
    };

    const payload = {
      company_id: profileData?.company_id,
      credits: Number(credits?.toString().trim() || 0),
      razorpay_payment_id: transactionID,
      expected_amount: Number(amountWithGST),
      product: productConfig?.creditName,
    };

    try {
      const response = await axios.post(url, payload, { headers });
      // console.log('Payment Check Response:', response);
      return response;
    } catch (error) {
      console.error(
        "Payment Check Failed:",
        error.response?.data || error.message
      );
      return { error: error.response };
    }
  };

  const checkEsignPayment = async (transactionID) => {
    const url = "https://invoice.meon.co.in/process_esign_with_invoice";

    const headers = {
      Authorization: "Bearer ssdjhfmbsjdfhvssfeiorfhjvkbercnjsljcf3roujf",
      "Content-Type": "application/json",
    };

    const payload = {
      company_id: profileData?.company_id,
      credits: Number(credits?.toString().trim() || 0),
      digitalCredits: Number(0),
      razorpay_payment_id: transactionID,
      expected_amount: Number(amountWithGST),
    };

    try {
      const response = await axios.post(url, payload, { headers });
      // console.log('Payment Check Response:', response);
      return response;
    } catch (error) {
      console.error(
        "Payment Check Failed:",
        error.response?.data || error.message
      );
      return { error: error.response };
    }
  };

  const handleWalletWisePayment = async (transactionID) => {
    const payload={
      company_id: profileData?.company_id,
      credits: Number(credits?.toString().trim() || 0),
      razorpay_payment_id: transactionID,
      expected_amount: Number(amountWithGST),
      product_code: effectiveCreditProductCode,
    }

    setLoader(true);
    try {
      let response = await developerTollApi.addCreditsWalletWise(payload);
      console.log(response)
      return response;
    } catch (error) {
      console.error("Payment Check Failed:",error.response?.data || error.message);
      return { error: error.response };
    } finally {
        setLoader(false);
    }
  };

  return (
    <>
      <Modal open={addCreditOpen} onClose={() => setAddCreditOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "652px",
            backgroundColor: "#fff",
            boxShadow: 24,
            overflow: "hidden",
            borderRadius: "20px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: "27px 30px 25px 30px",
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontSize: "22px", fontWeight: 600, color: "#1D1D1D" }}
            >
              Add Credits
            </Typography>
            <Box
              sx={{
                height: 35,
                backgroundColor: "#FFF5E9",
                display: "flex",
                alignItems: "center",
                gap: 1,
                padding: "0 12px",
                borderRadius: "8px",
                justifyContent: "center",
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/credit.png`}
                alt="Credit"
                style={{ width: 21, height: 21 }}
              />
              <Typography
                sx={{ fontWeight: 400, fontSize: "16px", color: "#5C5C5C" }}
              >
                Available Credits : {allCredits || 0}{" "}
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              p: "27px 30px 40px 30px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                height: 64,
                background: "#FAFAFA",
                alignItems: "center",
                p: "0 30px",
                borderRadius: "10px 10px 0 0",
                border: "1px solid #D9D9D9",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "18px",
                  color: "#222222",
                  width: 295,
                }}
              >
                Type{" "}
              </Typography>
              <Divider
                orientation="vertical"
                flexItem
                sx={{
                  borderWidth: "0 0 0 thin !important",
                  margin: 0,
                  borderColor: "#D9D9D9",
                }}
              />
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "18px",
                  color: "#222222",
                  width: 295,
                  textAlign: "right",
                }}
              >
                Number of Credits
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                height: 64,
                background: "#ffffff",
                alignItems: "center",
                p: "0 30px",
                border: "1px solid #D9D9D9",
                borderTop: "none",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "16px",
                  color: "#555555",
                  width: 295,
                }}
              >
                {creditDisplayName}
              </Typography>
              <Divider
                orientation="vertical"
                flexItem
                sx={{
                  borderWidth: "0 0 0 thin !important",
                  margin: 0,
                  borderColor: "#D9D9D9",
                }}
              />
              <Box sx={{ width: 295, textAlign: "-webkit-right" }}>
                <Box
                  sx={{
                    width: 142,
                    height: 30,
                    background: "#EFEFEF",
                    display: "flex",
                    alignItems: "center",
                    padding: "1px",
                    borderRadius: "5px",
                  }}
                >
                  <IconButton
                    onClick={decreasecredits}
                    size="small"
                    sx={{
                      background: "#ffffff",
                      borderRadius: "5px 0 0 5px",
                      height: 28,
                      width: 30,
                    }}
                  >
                    <RemoveIcon />
                  </IconButton>
                  <TextField
                    value={credits}
                    type="number"
                    size="small"
                    variant="outlined"
                    sx={{
                      width: "100%",
                      height: "100%",
                      "& .MuiOutlinedInput-root": {
                        padding: 0,
                        height: "100%",
                        "& fieldset": { border: "none" },
                      },
                    }}
                    inputProps={{
                      step: 1,
                      sx: { textAlign: "center", height: "100%", padding: 0 },
                      // readOnly: true
                    }}
                    onKeyDown={(e) => {
                      if (["e", "E", "+", "-", "."].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onPaste={(e) => {
                      const paste = e.clipboardData.getData("text");
                      if (!/^\d+$/.test(paste)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const cleanedValue = e.target.value;
                      if (cleanedValue === "") {
                        setCredits("");
                        return;
                      }
                      let value = parseInt(cleanedValue);
                      if (!isNaN(value)) {
                        // Allow typing any value up to 10000
                        // Validation for minimum (25) will be handled by button disabled state
                        // previously we were checking the value >= productConfig?.minQuantity and value <= 10000 but now we are allowing to type any value up to 10000
                        if (value <= 10000) {
                          setCredits(value);
                          setShowBulkText(value > 999);
                        }
                      }
                      // setCredits(Number(value))
                    }}
                  />
                  <IconButton
                    onClick={increasecredits}
                    size="small"
                    sx={{
                      background: "#ffffff",
                      borderRadius: "0 5px 5px 0",
                      height: 28,
                      width: 30,
                    }}
                  >
                    <AddIcon />
                  </IconButton>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                minHeight: 64,
                background: "#FFFFFF",
                alignItems: "center",
                borderRadius: "0 0 10px 10px",
                border: "1px solid #D9D9D9",
                borderTop: "none",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  p: "0 30px",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: "16px",
                    color: "#555555",
                    width: 295,
                    p: "15px 0 0 0",
                  }}
                >
                  Total item * {productConfig?.price || 0}{" "}
                </Typography>
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{
                    borderWidth: "0 0 0 thin !important",
                    margin: 0,
                    borderColor: "#D9D9D9",
                  }}
                />
                <Box sx={{ width: 295, textAlign: "right", p: "15px 0 0 0" }}>
                  <Typography
                    sx={{ fontWeight: 500, fontSize: "18px", color: "#555555" }}
                  >
                    {(credits * productConfig?.price || 0).toFixed(2)}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  p: "0 30px",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: "16px",
                    color: "#555555",
                    width: 295,
                    p: "0 0 15px 0",
                  }}
                >
                  GST (18%){" "}
                </Typography>
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{
                    borderWidth: "0 0 0 thin !important",
                    margin: 0,
                    borderColor: "#D9D9D9",
                  }}
                />
                <Box sx={{ width: 295, textAlign: "right", p: "0 0 15px 0" }}>
                  <Typography
                    sx={{ fontWeight: 500, fontSize: "18px", color: "#555555" }}
                  >
                    {(
                      ((credits * productConfig?.price || 0) * 18) /
                      100
                    ).toFixed(2)}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: "16px",
                    color: "#1D1D1D",
                    width: 295,
                    p: "15px 0 15px 30px",
                    background: "#FAFAFA",
                    borderBottomLeftRadius: "10px",
                  }}
                >
                  Total Payable Amount{" "}
                </Typography>
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{
                    borderWidth: "0 0 0 thin !important",
                    margin: 0,
                    borderColor: "#D9D9D9",
                  }}
                />
                <Box
                  sx={{
                    width: 295,
                    textAlign: "right",
                    p: "14px 30px 13px 0",
                    background: "#FAFAFA",
                    borderBottomRightRadius: "10px",
                  }}
                >
                  <Typography
                    sx={{ fontWeight: 600, fontSize: "18px", color: "#1D1D1D" }}
                  >
                    {amountWithGST}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
          {showBulkText && (
            <Typography
              sx={{
                textAlign: "center",
                fontWeight: 400,
                fontSize: "15px",
                color: "#185cb7",
                pb: 2,
                minHeight: "39px",
              }}
            >
              For bulk orders, please contact us at sales@meon.co.in"
            </Typography>
          )}
          <Divider />
          <Box
            sx={{
              p: "15px 30px 17px 30px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: "auto",
                gap: "20px",
              }}
            >
              <Button
                variant="contained"
                sx={{
                  width: "130px",
                  height: 46,
                  color: "#1D1D1D",
                  background: "transparent",
                  textTransform: "none",
                  fontSize: "16px",
                  borderRadius: "10px",
                  border: "1px solid #D2D2D2",
                  boxShadow: "none",
                  fontWeight: "500",
                }}
                onClick={() => {
                  setAddCreditOpen(false);
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{
                  width: "253px",
                  height: 46,
                  color: "#ffffff",
                  background: "#185CB7",
                  textTransform: "none",
                  fontSize: "16px",
                  borderRadius: "10px",
                  border: "1px solid #185CB7",
                  boxShadow: "none",
                  fontWeight: "500",
                  "&:disabled": {
                    background: "#E4E4E4",
                    color: "#ffffff",
                    borderColor: "#E4E4E4",
                  },
                }}
                onClick={handlePayment}
                disabled={credits < minimumCredits}
              >
                Proceed to Make Payment
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Modal open={paymentsuccess}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "652px",
            backgroundColor: "#fff",
            boxShadow: 24,
            overflow: "hidden",
            borderRadius: "20px",
          }}
        >
          <Box
            sx={{
              p: "46px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            <Box sx={{ alignSelf: "center" }}>
              <img
                src={`${process.env.PUBLIC_URL}/images/creditSuccess.svg`}
                alt="success"
                style={{ height: 132 }}
              />
            </Box>
            <Typography
              variant="p"
              sx={{
                marginTop: "38px",
                fontSize: "18px",
                fontWeight: 600,
                color: "#1D1D1D",
                textAlign: "center",
              }}
            >
              Your Credit has been Successfully Added!
            </Typography>
            <Typography
              variant="p"
              sx={{
                marginTop: "22px",
                fontSize: "16px",
                fontWeight: 400,
                color: "#5C5C5C",
                textAlign: "center",
              }}
            >
              You can now use your newly added credits to complete transaction
              seamlessly.
            </Typography>

            <Box sx={{ display: "flex", justifyContent: "center", mt: "38px" }}>
              <Button
                variant="contained"
                sx={{
                  width: "253px",
                  height: 46,
                  color: "#ffffff",
                  background: "#185CB7",
                  textTransform: "none",
                  fontSize: "16px",
                  borderRadius: "10px",
                  border: "1px solid #185CB7",
                  boxShadow: "none",
                  fontWeight: "500",
                }}
                onClick={handleBackToCredits}
              >
                Back to Credits
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default AddCredits;
